import React from 'react';
import { IconProps, withWrapper } from './index';

type Props = IconProps;

const EdgeCornerSvgIcon = ({ fillColor = '#fff', ...restProps }: Props) => (
  <svg
    fill='none'
    height={50}
    width={50}
    xmlns='http://www.w3.org/2000/svg'
    {...restProps}
  >
    <path
      clipRule='evenodd'
      d='M50 0H0v50h25V37c0-6.627 5.373-12 12-12h13z'
      fill={fillColor}
      fillRule='evenodd'
    />
  </svg>
);

export default withWrapper(EdgeCornerSvgIcon);
